/** @jsx jsx */

import { Children, Fragment as _, memo, useContext } from 'react';
import { jsx } from '@emotion/core';
import EditableText from 'components/lib/EditableText';
import renderBlock from 'services/apiHelpers/renderBlock';
import {
  Row,
  Column,
  SingleColumnLayout,
  TwoColumnLayout,
} from 'components/UI/ColumnAndRow';
import Image from 'components/lib/Image';
import Video from 'components/lib/Video';
import SVG from 'components/lib/SVG';
import ContinueBtn from 'components/lib/ContinueBtn/continueBtn_v2';
import Container from 'components/Layouts/ContainerLogical';
import { interactionContext as InteractionContext } from './interactionContext';
import Media, { MediaContext, IMediaContext } from 'components/lib/Media';
import { imgPlaceholders } from 'components/lib/Image';
import Audio from 'components/lib/Audio';
import Transcript from 'components/lib/Video/Transcript';
import Embed from 'components/lib/Embed';
import PDF from 'components/lib/PDF';
import { OpenPDF } from 'components/lib/PDF/OpenPDF';
import { Block } from 'factories/block';
import getBlockById from 'services/apiHelpers/getBlockById';
import shouldUpdate from 'services/shouldUpdate';
import EditableBtn from 'components/lib/EditableBtn';
import SelectOptionsRoot from './SelectOptionsRoot';
import SelectOptions from './SelectOptions';
import SelectOption from './SelectOption';
import Feedback from 'components/lib/Feedback/Feedback_updated_022022';
import Dropdown_default from 'assets/Short Rectangle.svg';
import longRectangle from 'assets/Long Rectangle.svg';

const Components = {
  Row,
  Column,
  Text: EditableText,
  Image: ({ children, ...props }) => {
    const mediaContext = useContext(MediaContext) as IMediaContext;
    const { isAdditionalMedia } = mediaContext;

    return (
      <Image
        {...{
          ...props,
          placeholder: !isAdditionalMedia
            ? Dropdown_default
            : longRectangle || imgPlaceholders[1],
        }}
      />
    );
  },
  InteractionColumn: ({ children, ...props }) => {
    const interactionContext = useContext(InteractionContext);
    const { includeAdditionalTextField } = interactionContext.props;
    const [select, txt] = children;

    if (!includeAdditionalTextField) {
      return select;
    }

    return (
      <_>
        {select}
        <div
          style={{
            margin: '20px 0 0 0',
          }}
        >
          {txt}
        </div>
      </_>
    );
  },

  TwoColumnLayout,
  SingleColumnLayout,
  ContinueButton: ContinueBtn,
  Video,
  Audio,
  Transcript,
  SVG,
  Embed,
  Media,
  PDF,
  OpenPDF,
  SelectOptionsRoot,
  SelectOptions,
  SelectOption,
  Question: ({ children, ...props }) => children,
  Feedback,
  Correct: ({ children, ...props }) => children,
  Incorrect: ({ children, ...props }) => children,
  Attempt: ({ children, ...props }) => children,
  EditableButton: EditableBtn,
};

const SelectOptionsDisplay = memo((props: any) => {
  const interactionBlock = getBlockById(props.blockId);

  return (
    <Container
      id={interactionBlock.id}
      key={interactionBlock.id}
      {...interactionBlock.props}
      {...props}
    >
      <InteractionContext.Provider
        value={{ ...interactionBlock, updateItemsSeen: null }}
      >
        {(interactionBlock.children as Block[]).map((child) => {
          return renderBlock(child, Components);
        })}
      </InteractionContext.Provider>
    </Container>
  );
}, shouldUpdate as any);

export default SelectOptionsDisplay;
